import { RendererService } from './../renderer.service';
import { Component } from '@angular/core';
import { EntityComponent } from '../share/entity-component';
import { LineModel } from '../../model';
import {
  Geometry,
  Line,
  LineBasicMaterial,
  LineDashedMaterial,
  Vector3,
} from 'three';
import { SceneService } from '../scene.service';

@Component({
  selector: 'ng3-line',
  templateUrl: './line.component.html',
  styleUrls: ['./line.component.css'],
})
export class LineComponent extends EntityComponent<LineModel> {
  constructor(sceneService: SceneService, renderer: RendererService) {
    super(sceneService, renderer);
  }
  createEntity(model: LineModel) {
    const geomotery = new Geometry();
    geomotery.vertices.push(model.start);
    geomotery.vertices.push(model.end);
    if (model.style === 'Dashed') {
      const material = new LineDashedMaterial({
        color: model.color,
        linewidth: 2,
        scale: 1,
        dashSize: 0.5,
        gapSize: 0.25,
      });
      const line = new Line(geomotery, material);
      line.computeLineDistances();
      return line;
    } else {
      const material = new LineBasicMaterial({ color: model.color });
      return new Line(geomotery, material);
    }
  }
  defaultModel() {
    return new LineModel(new Vector3(0, 0, 0), new Vector3(100, 100, 100));
  }
  updateEntity(model: LineModel, entity: Line) {
    function update(g: Geometry) {
      g.vertices[0].copy(model.start);
      g.vertices[1].copy(model.end);
      g.verticesNeedUpdate = true;
    }
    update(entity.geometry as Geometry);
    // console.log(model);
    return entity;
  }
}
